import styled from "styled-components"

export const QuestionCardInputTEXTAREA = styled.textarea`
  font-family: var(--font-family--default);
  outline: 0;
  border: none;
  padding-left: 0;
  padding-right: 0;
  resize: none;
  overflow: hidden;
`
